import {defineStore} from 'pinia';
import api from '@/services/api';

export const useAlertsStore = defineStore('alerts', {
  state: () => ({
    releaseMandatory: {
      count: 0,
      stayIds: [],
      loadedAt: null,
      loading: false
    }
  }),
  actions: {
    async loadReleaseMandatoryAlerts() {
      if (this.releaseMandatory.loading) return;

      this.releaseMandatory.loading = true;
      try {
        const {data} = await api.get('/alerts/release-mandatory');
        const stayIds = Array.isArray(data?.stayIds) ? data.stayIds.map(Number).filter(n => Number.isFinite(n) && n > 0) : [];
        this.releaseMandatory.count = Number(data?.count ?? stayIds.length) || stayIds.length;
        this.releaseMandatory.stayIds = stayIds;
        this.releaseMandatory.loadedAt = new Date().toISOString();
      } catch (e) {
        // still: Header/Dashboard sollen nicht "kaputt" gehen
        this.releaseMandatory.count = 0;
        this.releaseMandatory.stayIds = [];
      } finally {
        this.releaseMandatory.loading = false;
      }
    }
  }
});
